import { get } from 'svelte/store';
//Helpers
import { is_gen_2, load_image_from, real_id } from 'src/helpers/interface_helpers';
import {
	findDevicesByChannel,
	findDevicesByWebhookIP,
	getAvailableWebhookIP,
	getDeviceLabels,
} from './webhook_devices_helpers';
import { getURLWebhookParams } from './webhook_parse_url_helpers';
import { devices_settings } from 'src/stores/device-runtime/status';
//Types
import type { Device } from 'src/types/Device';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export type DevicesUrls = {
	index: number;
	url: string;
	foundDevices: Device[];
	devicesWithSameIP: string[];
}[];

export type StaticUrls = {
	index: number;
	url: string;
}[];

export type WebhookURLError = {
	show: boolean;
	required: string;
	invalid: string;
};

export const getURLActions = (
	urls: string[],
	device: Device,
): {
	devicesUrls: DevicesUrls;
	staticUrls: StaticUrls;
} => {
	const staticUrls = [];
	const devicesUrls = [];
	const devicesSettings = get(devices_settings);
	const deviceSettings = devicesSettings[real_id(device.id)];
	const deviceSSID = device.ssid || deviceSettings?.wifi_sta?.ssid || deviceSettings?.wifi?.sta?.ssid;

	urls.forEach((url, index) => {
		let foundDevices = [];
		let devicesWithSameIP: string[] = [];
		let ip = getAvailableWebhookIP(url);
		let devices: Device[] = findDevicesByWebhookIP(ip);

		if (devices.length) {
			for (let i = 0; i < devices.length; ++i) {
				const action: ActionJob = getURLWebhookParams(url, devices[i]);
				const currentDevice: Device = findDevicesByChannel(devices[i], action);
				if (currentDevice) {
					const id = real_id(currentDevice.id);
					const gen1 = !is_gen_2(currentDevice);
					const labelList = getDeviceLabels(action, currentDevice);
					const image = currentDevice?.image
						? load_image_from(currentDevice.image, currentDevice?.server)
						: null;
					const avatar = {
						image,
						icon: currentDevice?.icon,
						backgroundColor: currentDevice?.backgroundColor,
					};
					const settings = devicesSettings[id];
					const currentDeviceSSID =
						currentDevice.ssid || settings?.wifi_sta?.ssid || settings?.wifi?.sta?.ssid;

					let hasStaticIP = true;
					let isNotOnTheSameNetwork = false;

					if (currentDeviceSSID !== deviceSSID) {
						isNotOnTheSameNetwork = true;
					} else {
						let settings = devicesSettings[id];
						if (
							settings &&
							((gen1 && settings?.wifi_sta?.ipv4_method === 'dhcp') ||
								(!gen1 &&
									settings?.wifi?.sta?.ipv4mode !== 'static' &&
									settings?.eth?.ipv4mode !== 'static'))
						) {
							hasStaticIP = false;
						}
						if (!settings || !currentDeviceSSID) {
							labelList.unshift({
								icon: 'fas fa-wifi-slash',
								iconColor: '--color-muted',
							});
						}
					}

					foundDevices.push({
						id: currentDevice.id,
						title: currentDevice.name,
						subtitle: {
							value: `${currentDeviceSSID && !/\?\?\?/.test(currentDeviceSSID) ? currentDeviceSSID : ''} ${ip}`,
							bold: false,
							textSmall: true,
						},
						avatar,
						labelList,
						hasStaticIP,
						action,
						device: currentDevice,
						isNotOnTheSameNetwork,
					});
					if (!devicesWithSameIP.includes(id)) {
						devicesWithSameIP.push(id);
					}
				}
			}
		}

		if (foundDevices.length > 0) {
			devicesUrls.push({
				index,
				url,
				foundDevices,
				devicesWithSameIP,
			});
		} else {
			staticUrls.push({ index, url });
		}
	});
	return { devicesUrls, staticUrls };
};
